// extracted by mini-css-extract-plugin
module.exports = {"arrow":"GalleryCarouselNavigationButtonPrev_arrow__1oUHz","buttonPrev":"GalleryCarouselNavigationButtonPrev_buttonPrev__1pDZ0"};